import { Link } from "react-router-dom";
import { OWNER } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[color:var(--accent)] mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="inline-block w-7 h-5 relative overflow-hidden border border-[color:var(--accent)]">
              <span className="absolute inset-0 bg-[color:var(--brg)]"></span>
              <span className="absolute inset-0 uj-line"></span>
            </span>
            <span className="font-display text-2xl">britcars.us</span>
          </div>
          <p className="text-sm text-[color:var(--ink-secondary)] leading-relaxed max-w-xs">
            A private collection of rare British motor cars, kept in motion by friends, weather and Sunday mornings.
          </p>
        </div>

        <div>
          <div className="eyebrow mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/collection" className="hover:text-[color:var(--brg)]">The Collection</Link></li>
            <li><Link to="/drives" className="hover:text-[color:var(--brg)]">The Drives</Link></li>
            <li><Link to="/memories" className="hover:text-[color:var(--brg)]">Memories</Link></li>
            <li><Link to="/videos" className="hover:text-[color:var(--brg)]">Films</Link></li>
            <li><Link to="/about" className="hover:text-[color:var(--brg)]">About</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-4">Correspondence</div>
          <a
            data-testid="footer-email-link"
            href={`mailto:${OWNER.email}`}
            className="font-display text-2xl hover:text-[color:var(--brg)] transition"
          >
            {OWNER.email}
          </a>
          <p className="mt-4 text-sm text-[color:var(--ink-secondary)]">
            We welcome drivers who can manage a manual gearbox.
          </p>
        </div>
      </div>
      <div className="border-t border-[color:var(--accent)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[color:var(--ink-muted)]">
          <span>© {new Date().getFullYear()} britcars.us — Caretaker, not seller.</span>
          <span className="font-display italic">Driving cars demand our attention. Never dull.</span>
        </div>
      </div>
    </footer>
  );
}
